<app-dl-header style="width: 100%"></app-dl-header>
<div class="container-fluid px-5">
  <div class="content">
    <router-outlet></router-outlet>
  </div>

  <app-dl-footer></app-dl-footer>
</div>
